const regularBirdTicketOptions = [{ value: "raffle-ticket-1", label: "1 Raffle Ticket", cost: 25 },
{ value: "raffle-ticket-3", label: "3 Raffle Tickets", cost: 50 },
{ value: "raffle-ticket-10", label: "10 Raffle Tickets", cost: 100 }];

const getTicketOptions = async () => {
    return regularBirdTicketOptions;
};

export default getTicketOptions;
